export const DUE_STYLE = {
  overdue: { label: "Overdue", chip: "bg-red-50 text-red-700 border-red-200", row: "border-l-red-500" },
  today: { label: "Due today", chip: "bg-amber-50 text-amber-800 border-amber-200", row: "border-l-amber-500" },
  soon: { label: "Due soon", chip: "bg-sky-50 text-sky-800 border-sky-200", row: "border-l-sky-400" },
  later: { label: "", chip: "bg-slate-50 text-slate-600 border-slate-200", row: "border-l-transparent" },
};

export const fmtDue = (iso) => (iso ? new Date(iso + "T00:00:00").toLocaleDateString(undefined, { day: "numeric", month: "short" }) : "");
